export default "__VITE_ASSET__6b496f23__"